module.exports = __webpack_public_path__ + "static/newsletterServices-6044fc29a5b4fb3df13ac6b1b9b65181.jpg";